<template>
  <UiCollapsible
    title="Filter"
    v-model:showContent="showContent"
    v-if="props.meta?.enabledFilterColumns?.length > 0"
    :showOptionsWhileCollapsed="false"
  >
    <div class="max-h-[23.5vh] overflow-scroll">
      <FormFromMetaComposable
        :meta="props.meta"
        v-model:value="data"
        form-type="filter"
        @keypress.enter.stop="apply()"
      />
    </div>
    <template #topright>
      <div class="flex flex-row-reverse gap-2">
        <PrimeButton
          class="mediumOutlinedDistructiveBtn"
          @click.stop="reset()"
          icon="pi pi-refresh text-[14px]"
          label="Reset"
        />
        <PrimeButton
          :class="
            isFilterFormEmpty ? 'cursor-not-allowed bg-gray-100 opacity-70' : ''
          "
          @click.stop="apply()"
          :disabled="isFilterFormEmpty"
          label="Filter"
          icon="pi pi-filter text-[14px]"
        />
      </div>
    </template>
  </UiCollapsible>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import type { IMetaComputed } from "~/scad-shared/types/scad";

const props = withDefaults(
  defineProps<{
    showFilterForm?: boolean;
    meta: IMetaComputed;
  }>(),
  {
    showFilterForm: true,
  }
);

const emit = defineEmits({
  apply: (filter: Indexable) => true,
});

const showContent = defineModel("showContent", { default: false });
const form = defineModel<Indexable>("form");
const filters = defineModel<Indexable>("filters");
const data = ref<Indexable>({});

const isFilterFormEmpty = computed(() => {
  if (!data.value || Object.keys(data.value).length === 0) {
    return true;
  }
  return Object.values(data.value).every(
    (value) => value === null || value === undefined || value === ""
  );
});

const { getFilterKey, getFilterValue } = useFilter();

function apply() {
  form.value = data.value;

  const queryFilters: { [key: string]: any } = {};

  // console.log(props.meta?.columnsMap);
  for (var filterKey in form.value) {
    if (filterKey.charAt(0) == "_" || form.value[filterKey] == null) continue;
    const columnMeta = props.meta?.columnsMap[filterKey];
    if (!columnMeta) continue;
    const key = getFilterKey(columnMeta);
    const filterValue = getFilterValue(columnMeta, form.value[filterKey]);

    queryFilters[key] = filterValue;
  }

  filters.value = queryFilters;

  emit("apply", queryFilters);
}

function reset() {
  form.value = {};
  data.value = {};
  filters.value = {};
  emit("apply", filters.value);
}
</script>

<style scoped></style>
